import React from "react";
import { IHistory } from "../../../../store/credit/types";
import { groupByKey } from "../../../../util/common";

interface IProps {
    groupData: IHistory[] | undefined;
}

const PrintCreditHistoryTwoYearPayment: React.FunctionComponent<IProps> = (props) => {
    const renderData = (data: IHistory) => {
        var mygroupdata = groupByKey(data.monthlyHistoryList, "year");
        if (Object.keys(mygroupdata).length === 0) {
            return <tr className="hide-label">
                <td role="cell" colspan="13">
                </td>
            </tr>
        }
        return (
            <React.Fragment>
                {Object.entries(mygroupdata).map(([key, val], index) => (
                    <tr>
                        <td className="table-label" key={"year-header-th" + index}>
                            {key}
                        </td>
                        {showRowData(mygroupdata[key])}
                    </tr>
                ))}
            </React.Fragment>
        );
    };

    const showtd = (value: string) => {
        switch (value) {
            case "C":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-good" title="0 days past due">
                            <em className="las la-chevron-circle-up"></em>
                            <span className="sr-only">0 days past due</span>
                        </div>
                    </td>
                );
            case "1":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-average" title="30-60 days past due">
                            <em className="las la-minus-circle"></em>
                            <span className="sr-only">30-60 days past due</span>
                        </div>
                    </td>
                );
            case "2":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-average" title="30-60 days past due">
                            <em className="las la-minus-circle"></em>
                            <span className="sr-only">30-60 days past due</span>
                        </div>
                    </td>
                );
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
            case "10":
            case "11":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-negative" title="Negative">
                            <em className="las la-chevron-circle-down"></em>
                            <span className="sr-only">Negative</span>
                        </div>
                    </td>
                );
            case " ":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-unknown" title="Unknown"></div>
                    </td>
                );
            default:
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-unknown" title="Unknown"></div>
                    </td>
                );
        }
    };

    const showRowData = (values: any) => {
        if (values != null && values.length > 0 && values.length < 12) {
            var year = values[0].year;
            for (var i = 0; i < 12; i++) {
                var historydata = values.find((history: { month: number }) => history.month === i + 1);
                if (historydata == null) {
                    values.splice(i, 0, { year: year, month: i + 1, status: " " });
                }
            }
        }

        return (
            <React.Fragment>
                {values && values.map((score: any, index: number) => <React.Fragment key={"td_ty_" + index}>{showtd(score.status)}</React.Fragment>)}
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            <div className="drawer-content" id="payment-history-print">
                <h3 className="sr-only">Two Year Payment History</h3>
                <ul className="list-reset list-inline text-align-right" id="table-key">
                    <li>
                        <div className="credit-report-payment-indicator status-good" title="0 days past due">
                            <em className="las la-chevron-circle-up"></em>
                        </div>
                        <span>0</span>
                    </li>
                    <li>
                        <div className="credit-report-payment-indicator status-average">
                            <em className="las la-minus-circle"></em>
                        </div>
                        <span>30-60</span>
                    </li>
                    <li>
                        <div className="credit-report-payment-indicator status-negative">
                            <em className="las la-chevron-circle-down"></em>
                        </div>
                        <span>Negative</span>
                    </li>
                    <li>
                        <div className="credit-report-payment-indicator status-unknown" title="Unknown"></div>
                        <span>Unknown</span>
                    </li>
                </ul>

                {props.groupData &&
                    props.groupData.map((history: IHistory) => (
                        <React.Fragment>
                            <React.Fragment>
                                <div className="margin-vertical-l"></div>
                                <div className="row between-xs margin-bottom-xs payment-table-header">
                                    <div className="col-xs flex-grow-null">
                                        <h4 className="content-table-title">{history.bureau}</h4>
                                    </div>
                                    <div className="col-xs flex-grow-null">
                                        <div className="credit-report-days-past-due">
                                            Days past due: <strong>0</strong>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-container scroll">
                                    <table className="m-table-generic table-payment-history">
                                        <caption className="sr-only">2 Year Payment History for {history.bureau}</caption>
                                        <thead>
                                            <tr>
                                                <th scope="col">Year</th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="January">Jan</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="February">Feb</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="March">Mar</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="April">Apr</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="May">May</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="June">Jun</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="July">Jul</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="August">Aug</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="September">Sep</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="October">Oct</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="November">Nov</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="December">Dec</abbr>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>{renderData(history)}</tbody>
                                    </table>
                                </div>
                            </React.Fragment>
                        </React.Fragment>
                    ))}
            </div>
        </React.Fragment>
    );
};

export default PrintCreditHistoryTwoYearPayment;
